module["exports"] = [
  "кв. ###"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ru/address/secondary_address.js
// module id = 2642
// module chunks = 2